import ModalBase from '../ModalBase/ModalBase';

function ThirdPartyCookiesModal({ isOpen, toggle }) {
  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header="Notice"
      body={
        <>
          Your browser appears to be blocking third-party cookies, which may
          break some functionalities of the site.
          <br />
          <br />
          Please contact us at{' '}
          <a href="mailto:support@promotionwingman.com">
            support@promotionwingman.com
          </a>{' '}
          if you are having any issues with any site features.
        </>
      }
      footer={
        <button
          className="btn btn-primary btn-submit"
          onClick={() => {
            toggle();
          }}
        >
          Understood
        </button>
      }
    />
  );
}

export default ThirdPartyCookiesModal;
